// extracted by mini-css-extract-plugin
module.exports = {"list":"_0fd55ca845--list--pjPay","list-item":"_0fd55ca845--list-item--q4au2","icon":"_0fd55ca845--icon--IHYkH","checked":"_0fd55ca845--checked--Wtefb"};